import { StoreForms } from './state'

export const getKeyByForm = (idForm: string) => {
  const forms = {
    partners: 'EntryID',
    partnersExt: 'EntryId',
    programCodes: 'EntryID',
    accreditationCodes: 'EntryID',
    myPartnerSet: 'EntryID',
    myPartnerListCSI: 'EntryId',
    contactCampaigns: 'EntryID',
    userRights: 'EntryID',
    callOutHistory: 'EntryID',
    searchCodes: 'EntryID',
    myCoverage: 'EntryID',
  }
  return forms[idForm] || 'EntryId'
}

type IRelation = {
  [key in StoreForms]?: {
    [key in StoreForms]?: {
      fieldLink: string
    }
  }
}

export const relations = (idForm: string): IRelation => {
  const relations: IRelation = {
    partners: {
      partnersExt: {
        fieldLink: 'PartnerID',
      },
    },
    partnersExt: {
      partners: {
        fieldLink: 'PartnerID',
      },
    },
  }

  return relations[idForm]
}
